import type React from "react";
import { cn, tv, type VariantProps } from "tailwind-variants";
import { toHoverItemCssClasses } from "#/_packages/umbrella/integrations/umbraco/utils/animation-utils.ts";

export type TextProps = VariantProps<typeof textBlock> & {
	id?: string | null;
	body?: React.ReactNode;
	htmlBody?: string;
	inlineField?: string;
	inlineElementKey?: string;
	readWidthToggle?: boolean;
	isDrawer?: boolean;
	className?: string;
	animationHoverType: string[] | null | undefined;
};

const textBlock = tv({
	base: "block__text rich-text mb-0-last",
	variants: {
		readWidthLength: {
			narrow: "read-width-narrow",
			normal: "read-width-normal",
			wide: "read-width-wide",
		},
		alignmentHorizontal: {
			start: "read-width-start",
			center: "read-width-center",
			end: "read-width-end",
			stretch: "read-width-center",
		},
		alignmentSelfVertical: {
			stretch: "",
			start: "self-start",
			center: "self-center",
			end: "self-end",
		},
		animationScrollType: {
			none: "",
			"anim-view-fadeIn-moveUp": "anim-view-fadeIn-moveUp",
			"anim-view-fadeIn-moveDown": "anim-view-fadeIn-moveDown",
			"anim-view-fadeIn-moveLeft": "anim-view-fadeIn-moveLeft",
		},
	},
});

export function Text({
	id,
	body,
	htmlBody,
	inlineField,
	inlineElementKey,
	className,
	animationScrollType,
	readWidthToggle,
	readWidthLength,
	alignmentHorizontal,
	alignmentSelfVertical,
	animationHoverType,
}: TextProps) {
	const hoverItemClasses = toHoverItemCssClasses(animationHoverType);

	return (
		<div
			data-inline-element-key={inlineElementKey}
			data-inline-field={inlineField}
			data-inline-field-kind={inlineField ? "rich-text" : undefined}
			id={id ?? undefined}
			className={cn(
				textBlock({
					readWidthLength: readWidthToggle ? readWidthLength : undefined,
					animationScrollType,
					alignmentHorizontal,
					alignmentSelfVertical,
				}),
				readWidthToggle && "read-width",
				hoverItemClasses,
				className,
			)}
			{...(htmlBody !== undefined
				? { dangerouslySetInnerHTML: { __html: htmlBody } }
				: {})}
		>
			{htmlBody === undefined ? body : null}
		</div>
	);
}
